import React from 'react';

export default function LoadingComponent() {
    return <svg className="animate-spin h-5 w-5 mr-3" viewBox="0 0 24 24"/>
}